import {ClienteModel, LoginParamModel, UsuarioLogadoModel} from '../model';
import { Component, OnInit } from '@angular/core';
import { constants } from '../app-constants';
import { AdvGrowlService } from 'primeng-advanced-growl';
import {AuthenticationService, UsuarioService} from '../service';
import {ActivatedRoute} from '@angular/router';
import {MensagemService} from '../service/mensagem.service';
import {ClienteService} from '../service';

@Component({
  selector: 'app-editar-cliente',
  templateUrl: './editar-cliente.component.html'
})

export class EditarClienteComponent implements OnInit {
  cliente: ClienteModel;
  login = new LoginParamModel();
  clienteParam = new ClienteModel();
  maskCpfCnpj: string;
  message: Array<any> = [];
  messageDados: Array<any> = [];
  constructor(private router: ActivatedRoute,
              private _clienteParam: ClienteModel,
              private usrService: UsuarioService,
              private mensagemService: MensagemService,
              private clienteService: ClienteService,
              private authenticationService: AuthenticationService) {
    this.clienteParam = _clienteParam;
  }

  ngOnInit() {
    this.cliente = JSON.parse(localStorage.getItem(constants.clienteKey));
    this.clienteParam = this.cliente;
    if (this.cliente.cpf != null) {
      if (this.cliente.cpf.length <= 13) {
        this.maskCpfCnpj = '000.000.000-00';
      } else {
        this.maskCpfCnpj = '00.000.000/0000-00';
      }
    }
    this.router.queryParams.subscribe(params => {
      if (params.msgSucesso !== undefined) {
        this.mensagemService.msgSucesso( 'msg_service_success_os_create' );
      }
    });
  }
  editar() {
    if (this.clienteParam.codigo === this.cliente.codigo && this.clienteParam.codigo) {
      this.cliente = this.clienteParam;
      if (this.cliente.email == null || this.cliente.email === '') {
        this.messageDados = [{severity: 'error', summary: 'Falha', detail: 'O e-mail é obrigatório'}];
      } else {
        this.clienteService.editarDados(this.cliente)
          .subscribe(response => {
            if (response.sucesso === false) {
              this.messageDados = [{severity: 'error', summary: 'Falha: ', detail: response.erros[0].description}];
            } else {
              localStorage.setItem(constants.clienteKey, JSON.stringify(this.cliente));
              this.messageDados = [{severity: 'success', summary: 'Sucesso: ', detail: 'Dados alterados com sucesso'}];
              window.scrollTo(0, 0);
              setTimeout(function () {
                window.location.reload();
              }, 1500);
            }
          });
      }
    }
  }
  trocarSenha() {
    const oldPass = (<HTMLInputElement>document.getElementById('oldPass')).value;
    const newPass = (<HTMLInputElement>document.getElementById('newPass')).value;
    const newPassConf = (<HTMLInputElement>document.getElementById('newPassConf')).value;
    if ((newPass.trim() === '') || (newPassConf.trim() === '') || (oldPass.trim() === '')) {
      this.message = [{severity: 'error', summary: 'Falha', detail: 'A senha não pode estar vazia'}];
    } else if (newPass.trim() === oldPass.trim()) {
      this.message = [{severity: 'error', summary: 'Falha', detail: 'A nova senha não pode ser igual a anterior'}];
    } else if (newPass.trim() !== newPassConf.trim()) {
      this.message = [{severity: 'error', summary: 'Falha', detail: 'A nova senha e sua confirmação devem ser iguais'}];
    } else {
      this.login.cliente = this.cliente.codigo;
      this.login.senha = oldPass;
      this.login.email = this.cliente.email;
      this.login.cpf = this.cliente.cpf;
      this.login.novaSenha = newPass.trim();
      this.usrService.alterarSenha(this.login)
        .subscribe(response => {
          if (response.sucesso === false) {
            this.onFail(response);
          } else {
            this.message = [{severity: 'success', summary: 'Sucesso', detail: 'Senha alterada com sucesso'}];
            const authService = this.authenticationService;
            setTimeout(function () {
              authService.logout();
            }, 2000);
          }
        });
    }
  }

  onFail (res) {
    this.message = [{severity: 'error', summary: 'Falha', detail: res.erros[0].description}];
  }
}
